import { FC } from 'react'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import useCountriesOfLegalEntities from '../../graphql/legalEntities/hooks/useCountriesOfLegalEntities'
import { useCollapse } from '../../routes/collapse-context'
import { GlobalAdminTable } from './GlobalAdminTable'
import { GlobalAdminInfoBox } from './GlobalAdminInfoBox'
import { useAuth } from '../../context/auth-context'
import { RoleName } from '../../types'
import useEmployeesWithHrOrDownloaderRoles from '../../graphql/employee/hooks/useEmployeesWithHrOrDownloaderRoles'

export const GlobalAdminView: FC = () => {
  const collapsed = useCollapse()
  const { user } = useAuth()
  const { data, error, loading } = useEmployeesWithHrOrDownloaderRoles()
  const { data: countries, error: countriesError, loading: countriesLoading } = useCountriesOfLegalEntities()

  if (loading || countriesLoading || error || countriesError || !data || !countries || !data.employeesWithHrOrDownloaderRole) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data}
          error={error}
          isPermissionDenied={!error && (!user.roles || user.roles.length === 0 || !user.roles.includes(RoleName.GlobalAdmin))}
        />
      </ContentContainer>
    )
  }
  return (
    <ContentContainer collapsed={collapsed}>
      <GlobalAdminInfoBox
        infoboxData={data.employeesWithHrOrDownloaderRole}
        availableCountries={countries.countriesOfLegalEntities || []}
      />
      <GlobalAdminTable employees={data.employeesWithHrOrDownloaderRole} />
    </ContentContainer>
  )
}
